import _uniq from 'lodash.uniq';

export function uniq<T = any>(collection: T[]) {
  return _uniq(collection);
}
